import { render, staticRenderFns } from "./LgMenuPanel.vue?vue&type=template&id=183778af&scoped=true&"
import script from "./LgMenuPanel.vue?vue&type=script&lang=js&"
export * from "./LgMenuPanel.vue?vue&type=script&lang=js&"
import style0 from "./LgMenuPanel.vue?vue&type=style&index=0&id=183778af&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183778af",
  null
  
)

export default component.exports